export interface InventoryItem {
  id: string;
  name: string;
  description: string;
  image: string;
  rarity: 'common' | 'rare' | 'epic' | 'legendary';
  acquiredAt: number;
}

export class Inventory {
  private static instance: Inventory;
  private items: InventoryItem[] = [];
  private readonly STORAGE_KEY = 'ai_cafe_inventory';

  private constructor() {
    this.loadFromStorage();
  }

  public static getInstance(): Inventory {
    if (!Inventory.instance) {
      Inventory.instance = new Inventory();
    }
    return Inventory.instance;
  }

  private loadFromStorage(): void {
    const storedItems = localStorage.getItem(this.STORAGE_KEY);
    if (storedItems) {
      try {
        this.items = JSON.parse(storedItems);
      } catch (e) {
        console.error('Failed to load inventory from storage:', e);
        this.items = [];
      }
    }
  }

  private saveToStorage(): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.items));
    } catch (e) {
      console.error('Failed to save inventory to storage:', e);
    }
  }

  public addItem(item: Omit<InventoryItem, 'acquiredAt'>): void {
    const newItem: InventoryItem = {
      ...item,
      acquiredAt: Date.now()
    };
    this.items.push(newItem);
    this.saveToStorage();
  }

  public removeItem(itemId: string): void {
    this.items = this.items.filter(item => item.id !== itemId);
    this.saveToStorage();
  }

  public getItems(): InventoryItem[] {
    return [...this.items];
  }

  public hasItem(itemId: string): boolean {
    return this.items.some(item => item.id === itemId);
  }

  public clear(): void {
    this.items = [];
    this.saveToStorage();
  }
} 